const TopArrowIcon = ({ viewBox = "0 0 8 11", className = "hayley-h-3 hayley-w-3 hayley-text-secondary", style = {} }) => {
  return (
    <svg viewBox={viewBox} fill="none" className={className} style={style}>
      <path d="M3.7998 9.80078V0.800781" stroke="#333333" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M0.799805 3.80078L3.7998 0.800781L6.7998 3.80078" stroke="#333333" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default TopArrowIcon;
